import { useEffect, useState } from 'react';

function useViewport(): { width: number; isSmallerScreen: boolean } {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  const isSmallerScreen = width < 481;

  return { width, isSmallerScreen };
}

export { useViewport };
